<div class="container mt-5 mb-5">
    <div class="row">
        <h1 class="text-center">Resultados de Servicios Públicos Municipales</h1>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-lightbulb circulo-icono-rojo icono-rojo"></i>
            <p class="mt-4">ALUMBRADO PÚBLICO</p>
            <b class="conoce-mas"  (click)="irDetalle('alumbrado')">Conoce mas > </b>
        </div>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-trash circulo-icono-cafe"></i>
            <p class="mt-4">LIMPIEZA Y RECOLECCIÓN</p>
            <b class="conoce-mas"  (click)="irDetalle('limpieza')">Conoce mas > </b>
        </div>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-recycle  circulo-icono-rojo"></i>
            <p class="mt-4">TRATAMIENTO Y DISPOSICIÓN FINAL DE RESIDUOS</p>
            <b class="conoce-mas" >Conoce mas > </b>
        </div>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-dungeon  circulo-icono-cafe"></i>
            <p class="mt-4">PANTEONES</p>
            <b class="conoce-mas" (click)="irDetalle('panteones')">Conoce mas > </b>
        </div>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-store  circulo-icono-rojo" style="padding:13px !important;"></i>
            <p class="mt-4">MERCADO MUNICIPAL NLD</p>
            <b class="conoce-mas" (click)="irDetalle('mercado')">Conoce mas > </b>
        </div>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-road circulo-icono-cafe"></i>
            <p class="mt-4">CALLES</p>
            <b class="conoce-mas" (click)="irDetalle('calles')">Conoce mas > </b>
        </div>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-tree circulo-icono-rojo"></i>
            <p class="mt-4">PARQUES, JARDINES Y PLAZAS</p>
            <b class="conoce-mas" (click)="irDetalle('parques')">Conoce mas > </b>
        </div>
        <div class="col-md-4 mt-5 text-center">
            <i class="fa fa-solid fa-water circulo-icono-cafe"></i>
            <p class="mt-4">DISTRIBUCION DE AGUA</p>
            <b class="conoce-mas">Conoce mas > </b>
        </div>
    </div>
</div>